import { Icon } from '@ant-design/compatible';

export const Antd3Icon = Icon;
